import { componentFactory } from '../component-factory';

export const Main = componentFactory('main', () => ({
  backgroundColor: 'white',
  height: '100%',
  margin: '0 auto',
  maxHeight: '418px',
  width: '100%',
}));
